// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

export const palette = {
  primary: {
    main: '#1072BA',
    contrastText: '#fff',
    light: '#d7ddf3',
  },
  secondary: {
    main: '#3959E5',
    contrastText: '#fff',
    dark: '#263C9C',
  },
  error: {
    main: '#D80027',
    contrastText: '#fff',
  },
  success: {
    main: '#0D9795',
    contrastText: '#fff',
  },
  warning: {
    main: '#F9A825',
    contrastText: '#fff',
  },
  info: {
    main: '#1072BA',
    light: '#E8EEFF',
  },
  grey: {
    500: '#79828D',
    600: '#56606d',
    700: '#2d405a',
  },
};

export const colorVariants = Object.keys(palette).map(key => key);
